<div class="mb-4 flex flex-col gap-2 rounded-lg border border-gray-200 bg-white p-6 filters-shadow">
  <div class="grid grid-cols-3 gap-6 py-2" [formGroup]="filterForm">
    <div class="group relative">
      <label
        for="pharmacyOwnerId"
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
        i18n="@@adminPharmaciesFilterOwnerId">
        Pharmacy Owner (Search)
      </label>
      <div class="relative">
        <input
          type="text"
          formControlName="searchControl"
          id="pharmacyOwnerId"
          name="pharmacyOwnerId"
          placeholder="Search by pharmacy owner name"
          i18n-placeholder="@@adminPharmaciesOwnerIdPlaceholder"
          class="w-full rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] text-gray-700 transition-colors outline-none placeholder:text-gray-300 hover:border-gray-600 focus:border-black ltr:pr-4 ltr:pl-10 rtl:pr-10 rtl:pl-4" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="absolute top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400 transition-colors group-focus-within:text-black group-hover:text-gray-600 ltr:left-3 rtl:right-3"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      @if (activeDropDown()) {
        <div class="absolute z-[110] mt-1 max-h-52 w-full overflow-y-auto rounded-md border bg-white py-4 shadow-lg">
          @if (loadingPharamcyOwners()) {
            <app-loading />
          }
          @if (errorPharamcyOwners()) {
            <app-error [apiError]="isArabic() ? 'حدث بعض الخطأ' : 'some error occured'" />
          } @else {
            @if (pharamcyOwnerResults().length === 0 && !loadingPharamcyOwners()) {
              <p
                i18n="@@noPharamciesData"
                class="mx-auto flex w-full justify-center border-b border-gray-50 px-4 py-2 text-center text-start text-sm transition-colors last:border-0 hover:bg-gray-50">
                No Pharamcy Owner matches this name
              </p>
            } @else if (pharamcyOwnerResults() && !loadingPharamcyOwners()) {
              @for (item of pharamcyOwnerResults(); track item.id) {
                <button
                  (click)="onSelectFullName(item)"
                  class="block w-full cursor-pointer border-b border-gray-50 px-4 py-2 text-start text-sm transition-colors last:border-0 hover:bg-gray-100">
                  {{ item.fullName }}
                </button>
              }
            }
          }
        </div>
      }
    </div>

    <!-- EMPLOYEE AUTO COMPLETE AND SELECT -->
    <div class="group relative" *hasScope="SCOPES.PHARMACIES.AUTO_COMPLETE_BY_EMPLOYEE_NAME">
      <label
        for="assignedToId"
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
        i18n="@@adminPharmaciesFilterAssignedToId">
        Assigned To (Search)
      </label>
      <div class="relative">
        <input
          type="text"
          id="assignedToId"
          name="assignedToId"
          formControlName="searchEmployeeControl"
          placeholder="Search by assigned employee"
          i18n-placeholder="@@adminPharmaciesAssignedToIdPlaceholder"
          class="w-full rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] text-gray-700 transition-colors outline-none placeholder:text-gray-300 hover:border-gray-600 focus:border-black ltr:pr-4 ltr:pl-10 rtl:pr-10 rtl:pl-4" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="absolute top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400 transition-colors group-focus-within:text-black group-hover:text-gray-600 ltr:left-3 rtl:right-3"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>

      @if (activeDropDownEmployees()) {
        <div class="absolute z-[110] mt-1 max-h-52 w-full overflow-y-auto rounded-md border bg-white py-4 shadow-lg">
          @if (loadingEmployeess()) {
            <app-loading />
          }
          @if (errorEmployeess()) {
            <app-error [apiError]="isArabic() ? 'حدث بعض الخطأ' : 'some error occured'" />
          } @else {
            @if (employeeResults().length === 0 && !loadingEmployeess()) {
              <p
                i18n="@@noEmployeesData"
                class="mx-auto flex w-full justify-center border-b border-gray-50 px-4 py-2 text-center text-start text-sm transition-colors last:border-0 hover:bg-gray-50">
                No Employees matches this name
              </p>
            } @else if (employeeResults() && !loadingEmployeess()) {
              @for (item of employeeResults(); track item.id) {
                <button
                  (click)="onSelectEmployee(item)"
                  class="block w-full cursor-pointer border-b border-gray-50 px-4 py-2 text-start text-sm transition-colors last:border-0 hover:bg-gray-100">
                  {{ item.fullName }}
                </button>
              }
            }
          }
        </div>
      }
    </div>

    <div class="group relative">
      <label
        for="statusId"
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
        i18n="@@adminPharmaciesFilterStatus">
        Status
      </label>
      <div class="status-dropdown-container relative" (clickOutside)="closeStatusDropdown()">
        <!-- Trigger Button -->
        <button
          type="button"
          (click)="toggleStatusDropdown()"
          class="flex w-full appearance-none items-center justify-between rounded-[10px] border border-gray-400 bg-white py-2.5 pr-10 pl-4 text-[14px] text-gray-700 transition-colors outline-none hover:cursor-pointer hover:border-gray-600 focus:border-black">
          <span class="truncate">
            @if (selectedStatusIds()?.length === 0) {
              <span class="text-gray-400" i18n="@@adminPharmaciesFilterStatusTitle">Filter by status</span>
            } @else {
              {{ selectedStatusIds()?.length }} {{ isArabic() ? "محدد" : "selected" }}
            }
          </span>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="pointer-events-none h-5 w-5 text-black transition-transform"
            [class.rotate-180]="showStatusDropdown()"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <!-- Dropdown List -->
        @if (showStatusDropdown()) {
          <div class="absolute z-50 mt-1 w-full rounded-[10px] border border-gray-200 bg-white shadow-lg">
            <!-- All Statuses option -->
            <div
              (click)="toggleStatus(undefined)"
              class="flex cursor-pointer items-center gap-2 px-4 py-2.5 text-[14px] hover:bg-gray-50">
              <div
                class="flex h-4 w-4 items-center justify-center rounded border-2"
                [class.border-black]="isStatusSelected(undefined)"
                [class.bg-black]="isStatusSelected(undefined)"
                [class.border-gray-300]="!isStatusSelected(undefined)">
                @if (isStatusSelected(undefined)) {
                  <svg
                    class="h-2.5 w-2.5 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="3">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                }
              </div>
              <span i18n="@@adminPharmaciesFilterAllStatuses">All Statuses</span>
            </div>

            <hr class="border-gray-100" />

            <!-- Status options -->
            @for (status of statuses(); track status.id) {
              <div
                (click)="toggleStatus(status.id)"
                class="flex cursor-pointer items-center gap-2 px-4 py-2.5 text-[14px] hover:bg-gray-50">
                <div
                  class="flex h-4 w-4 items-center justify-center rounded border-2"
                  [class.border-black]="isStatusSelected(status.id)"
                  [class.bg-black]="isStatusSelected(status.id)"
                  [class.border-gray-300]="!isStatusSelected(status.id)">
                  @if (isStatusSelected(status.id)) {
                    <svg
                      class="h-2.5 w-2.5 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="3">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  }
                </div>
                <span>{{ isArabic() ? status.titleAr : isEnglish() ? status.titleEn : "" }}</span>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <div class="group relative">
      <label
        for="createdOnFrom"
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
        i18n="@@adminCategoriesCreatedOnFrom">
        Created From
      </label>
      <div class="relative">
        <input
          type="date"
          id="createdOnFrom"
          name="createdOnFrom"
          formControlName="createdOnFrom"
          [max]="today()"
          class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] text-gray-400 transition-colors outline-none placeholder:text-gray-400 hover:cursor-text hover:border-gray-600 focus:border-black"
          [class.border-red-500]="
            filterForm.get('createdOnFrom')?.invalid && filterForm.get('createdOnFrom')?.touched
          " />
      </div>
    </div>

    <div class="group relative">
      <label
        for="createdOnTo"
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
        i18n="@@adminCategoriesCreatedOnTo">
        Created To
      </label>
      <div class="relative">
        <input
          type="date"
          id="createdOnTo"
          name="createdOnTo"
          [min]="filterForm.get('createdOnFrom')?.value || ''"
          [max]="today()"
          formControlName="createdOnTo"
          class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] text-gray-400 transition-colors outline-none placeholder:text-gray-400 hover:cursor-text hover:border-gray-600 focus:border-black"
          [class.border-red-500]="filterForm.get('createdOnTo')?.invalid && filterForm.get('createdOnTo')?.touched" />

        @if (filterForm.hasError("invalidDateRange") && filterForm.get("createdOnTo")?.touched) {
          <p class="mt-1 text-[12px] text-red-500" i18n="@@dateRangeError">"Created To" must be after "Created From"</p>
        }
      </div>
    </div>
    <div *hasScope="SCOPES.PHARMACIES.AUTO_COMPLETE_BY_EMPLOYEE_NAME"></div>
    <div class="group relative">
      <label
        for="lastModificationOnFrom"
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
        i18n="@@lastModificationDateFrom">
        Last Modification Date From
      </label>
      <div class="relative">
        <input
          type="date"
          id="lastModificationOnFrom"
          name="lastModifiedOnFrom"
          formControlName="lastModifiedOnFrom"
          [max]="today()"
          [class.border-red-500]="
            filterForm.get('lastModifiedOnFrom')?.invalid && filterForm.get('lastModifiedOnFrom')?.touched
          "
          class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] text-gray-400 transition-colors outline-none placeholder:text-gray-400 hover:cursor-text hover:border-gray-600 focus:border-black" />
      </div>
    </div>

    <div class="group relative">
      <label
        for="lastModificationDateTo"
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
        i18n="@@lastModificationDateTo">
        Last Modification Date To
      </label>
      <div class="relative">
        <input
          type="date"
          id="lastModificationDateTo"
          name="lastModifiedOnTo"
          formControlName="lastModifiedOnTo"
          [min]="filterForm.get('lastModifiedOnFrom')?.value || ''"
          [max]="today()"
          class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] text-gray-400 transition-colors outline-none placeholder:text-gray-400 hover:cursor-text hover:border-gray-600 focus:border-black"
          [class.border-red-500]="
            filterForm.get('lastModifiedOnTo')?.invalid && filterForm.get('lastModifiedOnTo')?.touched
          " />
      </div>
    </div>
  </div>
  <div class="border-border flex justify-between border-t pb-4">
    <div class="flex flex-col gap-1.5 pt-4">
      <div class="group relative max-w-[275px]">
        <label
          for="orderBy"
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
          i18n="@@adminProductsSortBy">
          Sort By
        </label>
        <div class="flex gap-2">
          <div class="relative w-full">
            <select
              name="orderBy"
              id="orderBy"
              [(ngModel)]="filters().orderBy"
              class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] text-gray-700 transition-colors outline-none hover:cursor-pointer hover:border-gray-600 focus:border-black ltr:pr-10 ltr:pl-4 rtl:pr-4 rtl:pl-10">
              <option value="LAST_MODIFICATION_DATE" i18n="@@adminPharmaciesSortLastModified">Last Modified</option>
              <option value="CREATION_DATE" i18n="@@adminCategoriesSortCreatedDate">Creation Date</option>
              <option value="STATUS" i18n="@@adminPharmaciesFilterStatus">Status</option>
              <option value="PHARMACY_OWNER" i18n="@@adminPharmaciesTableOwner">Pharmacy Owner</option>
            </select>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="pointer-events-none absolute top-1/2 h-5 w-5 -translate-y-1/2 text-black transition-colors group-focus-within:text-black group-hover:text-gray-800 ltr:right-3 rtl:left-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
          <button
            (click)="onToggleSortOrder()"
            class="w-[100px] rounded-[10px] border border-gray-400 bg-white px-2.5 py-2.5 text-[14px] font-[500] text-gray-700 transition-colors hover:cursor-pointer hover:border-gray-600 hover:bg-gray-50 focus:border-black focus:outline-none">
            @if (filters().orderDir == "DESC") {
              <span i18n="@@adminCategoriesSortAsc">ASC</span>
            } @else {
              <span i18n="@@adminCategoriesSortDesc">DESC</span>
            }
          </button>
        </div>
      </div>
    </div>
    <div class="col-span-2 flex items-end justify-end gap-3">
      <button
        (click)="onResetFilters()"
        class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-5 py-1.5 text-[13px] font-[500] hover:cursor-pointer">
        <span i18n="@@adminProductsResetButton">Clear</span>
      </button>
      <button
        (click)="onApplyFilters()"
        class="bg-primary hover-bg-primary-hover rounded-[6px] px-5 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer">
        <span i18n="@@adminProductsApplyButton">Apply</span>
      </button>
    </div>
  </div>
</div>
